import { atom, selector } from "recoil";
import { getProperty } from "../utils/FPEUtils";
import { savedDisplayOperationState } from "../hooks/useDisplayOperation";
import axios from "axios";
import { disabledContentsWithID } from "./DisabledContentsState";
import { COMMUNICATE_ERROR_MESSAGE_DAILY_GET, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER } from "../constants/ErrorMessage";

export const RC_INFORMATION_PANEL = 'RC_INFORMATION_PANEL';

/**
 * RcInformationの表示・非表示
 */
export const rcInformationVisibleState = atom({
  key: 'rcInformationVisibleState',
  default: selector({
    key: 'rcInformationVisibleStateSelector',
    get: ({get}) => {
      const disabled = get(disabledContentsWithID(RC_INFORMATION_PANEL));
      return disabled ? false : getProperty(get(savedDisplayOperationState), `${RC_INFORMATION_PANEL}.visible`) || false;
    },
  })
});

/**
 * RC Daily
 */
export const rcDailyState = atom({
  key: 'rcDailyState',
  default: selector({
    key: 'rcDailyStateSelector',
    get: () => {
      const apiUrl = process.env.REACT_APP_RCINFO_API_URL;
      const apiKey = process.env.REACT_APP_RCINFO_API_KEY;
      return axios.get(`${apiUrl}/daily/get`, {
        headers: {
          'x-api-key': apiKey
        },
        errorHandle: {
          message: COMMUNICATE_ERROR_MESSAGE_DAILY_GET,
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
        }
      }).then(res => {
        return res.data[0];
      }).catch(e => {
        if (e.response?.status === 404) {
          return null;
        }
        console.error('RC Daily failed.', e);
      });
    }
  })
});